import React from 'react';
import ReactSVG from 'react-svg';
import * as _ from 'lodash';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

import noupdates from '../img/no-updates.svg';
import Item from './Item';

let EmptyScreen = ({ t }) => (
  <div className="u-text-center">
    <h3>{t('newsletter.archieveEmptyTitle')}</h3>
    <p className="u-weight-light">{t('newsletter.archieveEmptySubtitle')}</p>
    <Link to="/home" className="c-btn c-btn-outline">
      {t('general.goHome')}
    </Link>
    <ReactSVG
      src={noupdates}
      svgClassName="u-img-responsive u-margin-vertical-huge"
    />
  </div>
);

EmptyScreen = translate()(EmptyScreen);

const List = ({ newsletters }) =>
  _.isEmpty(newsletters) ? (
    <EmptyScreen />
  ) : (
    newsletters.map((newsletter, i) => (
      <Item
        key={newsletter._id}
        number={newsletters.length - i}
        newsletter={newsletter}
      />
    ))
  );

export default List;



// WEBPACK FOOTER //
// ./src/newsletters/List.js